<template>
	<div id="liucheng">
		<index>
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>常规</el-breadcrumb-item>
				<el-breadcrumb-item><a style="color: #000000;">流程审批</a></el-breadcrumb-item>
			</el-breadcrumb>
			<div class="nav-tab-bar-box">
				<div class="nav-tab-bar u-f-item">
					<div class="font_14 nav-tab-item" @click="twacherTap(index)" :class="index == MeunIndex ? 'active' : ''" v-for="(item, index) in Meun" :key="index">
						{{ item.name }}
					</div>
				</div>
			</div>
			<div class="content u-f">
				<div class="content-left">
					<!-- <div class="u-f-item meun-item" :class="meunLeftIndex == 0 ? 'meun-active' : ''" @click="meunLeftTap(0)">
						<div class="iconfont icon-bianji"></div>
						<div>流程申请</div>
					</div> -->
					<div class="u-f-item meun-item" :class="meunLeftIndex == 1 ? 'meun-active' : ''" @click="meunLeftTap(1)">
						<div class="iconfont icon-fabu"></div>
						<div>我的申请</div>
					</div>
					<div class="u-f-item meun-item" :class="meunLeftIndex == 2 ? 'meun-active' : ''" @click="meunLeftTap(2)">
						<div class="iconfont icon-caogao"></div>
						<div>抄送给我</div>
					</div>
					<div class="font_blod font_16 p-t-b">审核</div>
					<div class="u-f-item meun-item" :class="meunLeftIndex == 3 ? 'meun-active' : ''" @click="meunLeftTap(3)">
						<div class="iconfont icon-yishenhe"></div>
						<div>未审核</div>
					</div>
					<div class="u-f-item meun-item" :class="meunLeftIndex == 4 ? 'meun-active' : ''" @click="meunLeftTap(4)">
						<div class="iconfont icon-yishenhe1"></div>
						<div>已审核</div>
					</div>
				</div>
				<!-- 流程申请 -->
				<div class="content-right" v-if="meunLeftIndex == 0">
					<el-row :gutter="20">
						<el-col :span="6">
							<div class="content-item">
								<div class="u-f-item box1">
									<i class="iconfont icon-yuyue"></i>
									<span>请假申请</span>
								</div>
								<div class="u-f-justify btn" @click="activityVisible1 = true">申请</div>
							</div>
						</el-col>
						<el-col :span="6">
							<div class="content-item">
								<div class="u-f-item box1">
									<i class="iconfont icon-13"></i>
									<span>物品领用/借用</span>
								</div>
								<div class="u-f-justify btn" @click="activityVisible4 = true">申请</div>
							</div>
						</el-col>
						<el-col :span="6">
							<div class="content-item">
								<div class="u-f-item box1">
									<i class="iconfont icon-wenjian"></i>
									<span>公文流转</span>
								</div>
								<div class="u-f-justify btn" @click="activityVisible5 = true">申请</div>
							</div>
						</el-col>
						<el-col :span="6">
							<div class="content-item">
								<div class="u-f-item box1">
									<i class="iconfont icon-wodekebiao"></i>
									<span>调课申请</span>
								</div>
								<div class="u-f-justify btn" @click="activityVisible6 = true">申请</div>
							</div>
						</el-col>
						<el-col :span="6">
							<div class="content-item">
								<div class="u-f-item box1">
									<i class="iconfont icon-huodong"></i>
									<span>活动申请</span>
								</div>
								<div class="u-f-justify btn" @click="activityVisible = true">申请</div>
							</div>
						</el-col>
						<el-col :span="6">
							<div class="content-item">
								<div class="u-f-item box1">
									<i class="iconfont icon-kecheng2"></i>
									<span>公开课申请</span>
								</div>
								<div class="u-f-justify btn" @click="activityVisible3 = true">申请</div>
							</div>
						</el-col>
						<el-col :span="6">
							<div class="content-item">
								<div class="u-f-item box1">
									<i class="iconfont icon-baoxiu"></i>
									<span>安全隐患申报</span>
								</div>
								<div class="u-f-justify btn" @click="activityVisible2 = true">申请</div>
							</div>
						</el-col>
					</el-row>
				</div>
				<!-- 我的申请 -->
				<div class="content-right" v-if="meunLeftIndex == 1">
					<div class="title u-f-item u-f-jsb">
						<div>
							共{{ total }}条数据
							<!-- <span class="btn" @click="selectAll">选择全部</span> -->
						</div>
					</div>
					<el-table
						:data="Mylist"
						height="98%"
						ref="multipleTable"
						tooltip-effect="dark"
						@selection-change="handleSelectionChange"
						style="width: 100%;border: 1px solid #EEEEEE;"
						key="2"
					>
						<el-table-column type="selection" width="55"></el-table-column>
						<el-table-column label="序号" type="index" width="80" align="center"></el-table-column>
						<el-table-column prop="title" label="名称" align="center" :filters="filters" :filter-method="filterHandler"></el-table-column>
						<el-table-column prop="createtime" label="发起时间" align="center"></el-table-column>
						<el-table-column prop="status" label="审核状态" align="center">
							<template slot-scope="scope">
								<el-tag v-if="scope.row.status == 1">待审核</el-tag>
								<el-tag v-if="scope.row.status == 2">已通过</el-tag>
								<el-tag v-if="scope.row.status == 3">未通过</el-tag>
								<el-tag v-if="scope.row.status == 4">已撤回</el-tag>
							</template>
						</el-table-column>
						<el-table-column align="center" label="操作" width="150">
							<template slot-scope="scope">
								<el-button @click="openDetails(scope.row)" type="text" size="small">详情</el-button>
								<!-- <el-button @click="delcourse(scope.row.id, scope.row.time_id)" type="text" size="small" style="color:red;">撤回</el-button> -->
							</template>
						</el-table-column>
					</el-table>
					<div class="u-f-item u-f-jsb" style="padding: 15px 0;">
						<div class="u-f-item"><el-button type="danger" plain size="mini" @click="delActivit">删除</el-button></div>
						<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							:current-page.sync="page"
							:page-size="limit"
							layout="total, prev, pager, next"
							:total="total"
						></el-pagination>
					</div>
				</div>
				<!-- 我的抄送 -->
				<div class="content-right" v-if="meunLeftIndex == 2">
					<div class="title u-f-item u-f-jsb">
						<div>共{{ total }}条数据</div>
					</div>
					<el-table :data="copyToList" height="90%" style="width: 100%;border: 1px solid #EEEEEE;">
						<el-table-column label="序号" type="index" width="80" align="center"></el-table-column>
						<el-table-column prop="title" label="名称" align="center"></el-table-column>
						<el-table-column prop="createtime" label="发布时间" align="center"></el-table-column>
						<el-table-column prop="status" label="审核状态" align="center">
							<template slot-scope="scope">
								<el-tag v-if="scope.row.status == 1">待审核</el-tag>
								<el-tag v-if="scope.row.status == 2">已通过</el-tag>
								<el-tag v-if="scope.row.status == 3">未通过</el-tag>
								<el-tag v-if="scope.row.status == 4">已撤回</el-tag>
							</template>
						</el-table-column>
						<el-table-column align="center" label="操作" width="100">
							<template slot-scope="scope">
								<el-button @click="openDetails(scope.row)" type="text" size="small">详情</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div class="u-f-right" style="padding: 15px 0;">
						<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							:current-page.sync="page"
							:page-size="limit"
							layout="total, prev, pager, next"
							:total="total"
						></el-pagination>
					</div>
				</div>
				<!-- 未审核 -->
				<div class="content-right" v-if="meunLeftIndex == 3">
					<div class="title u-f-item u-f-jsb">
						<div>共{{ total }}条数据</div>
					</div>
					<el-table :data="copyToList" height="90%" style="width: 100%;border: 1px solid #EEEEEE;">
						<el-table-column label="序号" type="index" width="80" align="center"></el-table-column>
						<el-table-column prop="title" label="名称" align="center"></el-table-column>
						<el-table-column prop="createtime" label="发布时间" align="center"></el-table-column>
						<el-table-column prop="status" label="审核状态" align="center">
							<template slot-scope="scope">
								<el-tag v-if="scope.row.status == 1">待审核</el-tag>
								<el-tag v-if="scope.row.status == 2">已通过</el-tag>
								<el-tag v-if="scope.row.status == 3">未通过</el-tag>
								<el-tag v-if="scope.row.status == 4">已撤回</el-tag>
							</template>
						</el-table-column>
						<el-table-column align="center" label="操作" width="100">
							<template slot-scope="scope">
								<el-button @click="openDetails(scope.row)" type="text" size="small">详情</el-button>
								<el-button @click="openaudit(scope.row)" type="text" size="small" style="color:red;">审核</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div class="u-f-right" style="padding: 15px 0;">
						<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							:current-page.sync="page"
							:page-size="limit"
							layout="total, prev, pager, next"
							:total="total"
						></el-pagination>
					</div>
				</div>
				<!-- 已审核 -->
				<div class="content-right" v-if="meunLeftIndex == 4">
					<div class="title u-f-item u-f-jsb">
						<div>共{{ total }}条数据</div>
					</div>
					<el-table :data="copyToList" height="90%" style="width: 100%;border: 1px solid #EEEEEE;">
						<el-table-column label="序号" type="index" width="80" align="center"></el-table-column>
						<el-table-column prop="title" label="名称" align="center"></el-table-column>
						<el-table-column prop="createtime" label="发布时间" align="center"></el-table-column>
						<el-table-column prop="status" label="审核状态" align="center">
							<template slot-scope="scope">
								<el-tag v-if="scope.row.status == 1">待审核</el-tag>
								<el-tag v-if="scope.row.status == 2">已通过</el-tag>
								<el-tag v-if="scope.row.status == 3">未通过</el-tag>
								<el-tag v-if="scope.row.status == 4">已撤回</el-tag>
							</template>
						</el-table-column>
						<el-table-column align="center" label="操作" width="100">
							<template slot-scope="scope">
								<el-button v-if="scope.row.status == 2&&detailsType!=3&&detailsType!=6&&detailsType!=7" @click="print(scope.row)" type="text" size="small">打印</el-button>
								<el-button @click="openDetails(scope.row)" type="text" size="small">详情</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div class="u-f-right" style="padding: 15px 0;">
						<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							:current-page.sync="page"
							:page-size="limit"
							layout="total, prev, pager, next"
							:total="total"
						></el-pagination>
					</div>
				</div>
			</div>
			<!-- 活动申请 -->
			<el-dialog title="活动申请" :visible.sync="activityVisible" width="600px" :before-close="handleClose2">
				<div class="edit-box">
					<div class="u-f-item input-box">
						<div class="input-lebal">
							<span>*</span>
							活动标题
						</div>
						<el-input v-model="title" placeholder="请输入活动标题" style="width: 70%;"></el-input>
					</div>
					<div class="u-f-item input-box">
						<div class="input-lebal">
							<span>*</span>
							开始时间
						</div>
						<el-date-picker value-format="yyyy-MM-dd H:mm" v-model="start_time" type="datetime" placeholder="选择日期"></el-date-picker>
					</div>
					<div class="u-f-item input-box">
						<div class="input-lebal">
							<span>*</span>
							结束时间
						</div>
						<el-date-picker value-format="yyyy-MM-dd H:mm" v-model="end_time" type="datetime" placeholder="选择日期"></el-date-picker>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal" style="margin-top: 10px;">
							<span>*</span>
							活动内容
						</div>
						<el-input v-model="explain" type="textarea" :rows="3" placeholder="请输入活动内容" style="width: 70%;"></el-input>
					</div>
					<div class="u-f-item input-box">
						<div class="input-lebal">
							<span>*</span>
							审批人
						</div>
						<div class="u-f-item" style="width: 70%;">
							<el-select v-model="audit" multiple popper-class="el_option" style="width: 80%;" @remove-tag="removeTag">
								<el-option style="display: none;" v-for="item in selectList" :key="item.id" :label="item.username" :value="item.id"></el-option>
							</el-select>
							<el-button style="margin-left: 10px;" @click="selectShowTap(1)">选择</el-button>
						</div>
						<!-- <el-select multiple v-model="audit" placeholder="请选择" style="width: 70%;">
							<el-option v-for="item in peopleList" :key="item.id" :label="item.username" :value="item.id"></el-option>
						</el-select> -->
					</div>
					<div class="u-f-item input-box">
						<div class="input-lebal">
							<span>*</span>
							抄送人
						</div>
						<div class="u-f-item" style="width: 70%;">
							<el-select v-model="ectype" multiple popper-class="el_option" style="width: 80%;" @remove-tag="removeTag">
								<el-option style="display: none;" v-for="item in selectList" :key="item.id" :label="item.username" :value="item.teacher_id"></el-option>
							</el-select>
							<el-button style="margin-left: 10px;" @click="selectShowTap(2)">选择</el-button>
						</div>
					</div>
				</div>
				<span slot="footer" class="dialog-footer u-f-item u-f-jsb">
					<el-button @click="closeActivity" size="small">取 消</el-button>
					<el-button type="primary" size="small" @click="submit()">确 定</el-button>
				</span>

				<!--选择 -->
				<div class="selectShow">
					<el-dialog custom-class="selectShow" :visible.sync="selectShow" width="800px" :before-close="handleClose" append-to-body>
						<div slot="title" class="u-f-item dialog-title"><div style="margin-right: 10px;">选择联系人</div></div>
						<div class="user-list-box" v-if="teacher_list.length">
							<div class="u-f-item u-f-jsb user-list-head">
								<div class="user-type-list u-f-item">
									<div
										class="user-type-item u-f-justify"
										@click="typeTap(index)"
										:class="typeIndex == index ? 'active' : ''"
										v-for="(item, index) in teacher_list"
										:key="index"
									>
										{{ item.name }}
										<span v-if="index + 1 < teacher_list.length">|</span>
									</div>
								</div>
								<el-input placeholder="请输入内容" prefix-icon="el-icon-search" style="width: 200px;" size="small" v-model="keys"></el-input>
							</div>
							<div class="user-list-content u-f">
								<div class="u-f2 left" v-if="teacher_list[typeIndex].data.length">
									<div
										class="left-item"
										@click="dataTap(index)"
										:class="dataIndex == index ? 'active' : ''"
										v-for="(item, index) in teacher_list[typeIndex].data"
										:key="index"
									>
										{{ item.name }}
									</div>
								</div>
								<div class="u-f4 right" v-if="teacher_list[typeIndex].data[dataIndex].teacher.length">
									<div class="list" v-if="teacher_list[typeIndex].data[dataIndex]">
										<div
											class="item"
											@click="teachTap(item)"
											:class="item.checked ? 'active' : ''"
											v-for="(item, index) in teacher_list[typeIndex].data[dataIndex].teacher"
											:key="index"
										>
											{{ item.username }}
										</div>
									</div>
								</div>
							</div>
						</div>
						<span slot="footer" class="dialog-footer u-f-item u-f-jsb">
							<el-button @click="reset" size="small">重置</el-button>
							<div class="u-f-item">
								<span style="color: #A4A4A4;margin-right: 10px;">{{ audit.length }}/{{ nums.length }}</span>
								<el-button type="primary" size="small" @click="selectShow = false">确 定</el-button>
							</div>
						</span>
					</el-dialog>
				</div>
			</el-dialog>
			<!-- 请假申请 -->
			<el-dialog title="请假申请" :visible.sync="activityVisible1" width="600px" :before-close="handleClose">
				<div class="edit-box">
					<div class="u-f-item input-box">
						<div class="input-lebal">
							<span>*</span>
							开始时间
						</div>
						<el-date-picker value-format="yyyy-MM-dd H:mm" v-model="start_time1" type="datetime" placeholder="选择日期"></el-date-picker>
					</div>
					<div class="u-f-item input-box">
						<div class="input-lebal">
							<span>*</span>
							结束时间
						</div>
						<el-date-picker value-format="yyyy-MM-dd H:mm" v-model="end_time1" type="datetime" placeholder="选择日期"></el-date-picker>
					</div>
					<div class="u-f-item input-box">
						<div class="input-lebal">
							<span>*</span>
							请假天数
						</div>
						<el-input v-model="day" placeholder="请输入请假天数" style="width: 70%;"></el-input>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal">
							<span>*</span>
							请假类型
						</div>
						<el-radio-group v-model="type" style="width: 80%">
							<el-radio :label="1" style="margin-bottom: 10px;">事假</el-radio>
							<el-radio :label="2" style="margin-bottom: 10px;">病假</el-radio>
							<el-radio :label="3" style="margin-bottom: 10px;">婚假</el-radio>
							<el-radio :label="7" style="margin-bottom: 10px;">丧假</el-radio>
							<el-radio :label="4" style="margin-bottom: 10px;">产假</el-radio>
							<el-radio :label="5" style="margin-bottom: 10px;">陪产假</el-radio>
							<el-radio :label="6" style="margin-bottom: 10px;">哺乳假</el-radio>
						</el-radio-group>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal" style="margin-top: 10px;">
							<span>*</span>
							请假原因
						</div>
						<el-input v-model="explain" type="textarea" :rows="3" placeholder="请输入请假原因" style="width: 70%;"></el-input>
					</div>
					
					<div class="u-f-item input-box">
						<div class="input-lebal">
							<span>*</span>
							审批人
						</div>
						<el-select multiple v-model="audit" placeholder="请选择" style="width: 70%;">
							<el-option v-for="item in peopleList" :key="item.id" :label="item.username" :value="item.id"></el-option>
						</el-select>
					</div>
					<div class="u-f-item input-box">
						<div class="input-lebal">
							<span>*</span>
							抄送人
						</div>
						<el-select multiple v-model="ectype" placeholder="请选择" style="width: 70%;">
							<el-option v-for="item in peopleList2" :key="item.id" :label="item.username" :value="item.id"></el-option>
						</el-select>
					</div>
				</div>
				<span slot="footer" class="dialog-footer u-f-item u-f-jsb">
					<el-button @click="closeActivity" size="small">取 消</el-button>
					<el-button type="primary" size="small" @click="submit1()">确 定</el-button>
				</span>
			</el-dialog>
			<!-- 安全隐患 -->
			<el-dialog title="安全隐患申报" :visible.sync="activityVisible2" width="600px" :before-close="handleClose">
				<div class="edit-box">
					<div class="u-f-item input-box">
						<div class="input-lebal">
							<span>*</span>
							隐患位置
						</div>
						<el-input v-model="site" placeholder="请输入隐患位置" style="width: 70%;"></el-input>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal" style="margin-top: 10px;">
							<span>*</span>
							描述
						</div>
						<el-input v-model="describe" type="textarea" :rows="3" placeholder="请输入隐患描述" style="width: 70%;"></el-input>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal">
							<span></span>
							图片
						</div>
						<div>
							<el-upload
								class="upload-demo"
								action="http://school.blzzxx.cn/v1/school_api/Common/upload"
								:on-success="handlePreview"
								:on-remove="handleRemove"
								list-type="picture"
								:limit="1"
								:file-list="fileList"
							>
								<el-button size="small" type="primary">点击上传</el-button>
								<!-- <div slot="tip" class="el-upload__tip">第二课堂成功照片</div> -->
							</el-upload>
						</div>
					</div>
					
					<div class="u-f-item input-box">
						<div class="input-lebal">
							<span>*</span>
							审批人
						</div>
						<el-select multiple v-model="audit" placeholder="请选择" style="width: 70%;">
							<el-option v-for="item in peopleList" :key="item.id" :label="item.username" :value="item.id"></el-option>
						</el-select>
					</div>
					<div class="u-f-item input-box">
						<div class="input-lebal">
							<span>*</span>
							抄送人
						</div>
						<el-select multiple v-model="ectype" placeholder="请选择" style="width: 70%;">
							<el-option v-for="item in peopleList2" :key="item.id" :label="item.username" :value="item.id"></el-option>
						</el-select>
					</div>
				</div>
				<span slot="footer" class="dialog-footer u-f-item u-f-jsb">
					<el-button @click="closeActivity" size="small">取 消</el-button>
					<el-button type="primary" size="small" @click="submit2()">确 定</el-button>
				</span>
			</el-dialog>
			<!-- 公开课申请 -->
			<el-dialog title="公开课申请" :visible.sync="activityVisible3" width="600px" :before-close="handleClose">
				<div class="edit-box">
					<div class="u-f-item input-box">
						<div class="input-lebal">
							<span>*</span>
							学校计划
						</div>
						<el-input v-model="plan" placeholder="请输入学校计划" style="width: 70%;"></el-input>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal">
							<span>*</span>
							功能室登记表
						</div>
						<div>
							<el-button size="mini" style="position: relative;">
								<input
									accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
									single
									ref="filElem"
									type="file"
									class="upload-file"
									@change="getFile"
								/>
								点击上传
							</el-button>
							<div class="u-f-item u-f-jsb file_box" v-if="file3.name" style="margin-top: 10px;width: 300px;">
								<div class="u-f-item">
									<i class="iconfont icon-excel" style="color: red;margin-right: 3px;"></i>
									{{ file3.name }}
								</div>
								<i class="el-icon-circle-check" style="color: #67C23A;"></i>
								<i class="el-icon-circle-close" style="color: #67C23A;" @click="delFile"></i>
							</div>
						</div>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal">
							<span>*</span>
							考勤表
						</div>
						<div>
							<el-button size="mini" style="position: relative;">
								<input
									accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
									single
									ref="filElem1"
									type="file"
									class="upload-file"
									@change="getFile1"
								/>
								点击上传
							</el-button>
							<div class="u-f-item u-f-jsb file_box" v-if="file1.name" style="margin-top: 10px;width: 300px;">
								<div class="u-f-item">
									<i class="iconfont icon-excel" style="color: red;margin-right: 3px;"></i>
									{{ file1.name }}
								</div>
								<i class="el-icon-circle-check" style="color: #67C23A;"></i>
								<i class="el-icon-circle-close" style="color: #67C23A;" @click="delFile1"></i>
							</div>
						</div>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal">
							<span>*</span>
							活动记录表
						</div>
						<div>
							<el-button size="mini" style="position: relative;">
								<input
									accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
									single
									ref="filElem2"
									type="file"
									class="upload-file"
									@change="getFile2"
								/>
								点击上传
							</el-button>
							<div class="u-f-item u-f-jsb file_box" v-if="file2.name" style="margin-top: 10px;width: 300px;">
								<div class="u-f-item">
									<i class="iconfont icon-excel" style="color: red;margin-right: 3px;"></i>
									{{ file2.name }}
								</div>
								<i class="el-icon-circle-check" style="color: #67C23A;"></i>
								<i class="el-icon-circle-close" style="color: #67C23A;" @click="delFile2"></i>
							</div>
						</div>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal">
							<span>*</span>
							授课照片
						</div>
						<div>
							<el-upload
								class="upload-demo"
								action="http://school.blzzxx.cn/v1/school_api/Common/upload"
								:on-success="handlePreview1"
								:on-remove="handleRemove1"
								list-type="picture"
								:limit="1"
								:file-list="fileList2"
							>
								<el-button size="small" type="primary">点击上传</el-button>
								<div slot="tip" class="el-upload__tip">第二课堂授课照片</div>
							</el-upload>
						</div>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal">
							<span>*</span>
							成功照片
						</div>
						<div>
							<el-upload
								class="upload-demo"
								action="http://school.blzzxx.cn/v1/school_api/Common/upload"
								:on-success="handlePreview2"
								:on-remove="handleRemove2"
								list-type="picture"
								:limit="1"
								:file-list="fileList1"
							>
								<el-button size="small" type="primary">点击上传</el-button>
								<div slot="tip" class="el-upload__tip">第二课堂成功照片</div>
							</el-upload>
						</div>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal" style="margin-top: 10px;">
							<span>*</span>
							课堂总结
						</div>
						<el-input v-model="summarize" type="textarea" :rows="3" placeholder="请输入课堂总结" style="width: 70%;"></el-input>
					</div>
					<div class="u-f-item input-box">
						<div class="input-lebal">
							<span>*</span>
							审批人
						</div>
						<el-select multiple v-model="audit" placeholder="请选择" style="width: 70%;">
							<el-option v-for="item in peopleList" :key="item.id" :label="item.username" :value="item.id"></el-option>
						</el-select>
					</div>
					<div class="u-f-item input-box">
						<div class="input-lebal">
							<span>*</span>
							抄送人
						</div>
						<el-select multiple v-model="ectype" placeholder="请选择" style="width: 70%;">
							<el-option v-for="item in peopleList2" :key="item.id" :label="item.username" :value="item.id"></el-option>
						</el-select>
					</div>
				</div>
				<span slot="footer" class="dialog-footer u-f-item u-f-jsb">
					<el-button @click="closeActivity" size="small">取 消</el-button>
					<el-button type="primary" size="small" @click="submit3()">确 定</el-button>
				</span>
			</el-dialog>
			<!-- 物品领用借用 -->
			<el-dialog title="物品领用/借用" :visible.sync="activityVisible4" width="600px" :before-close="handleClose">
				<div class="edit-box">
					<div class="u-f input-box">
						<div class="input-lebal">
							<span>*</span>
							类型
						</div>
						<el-radio-group v-model="assettype" style="width: 80%" @change="radioChange">
							<el-radio :label="2" style="margin-bottom: 10px;">物品领用</el-radio>
							<el-radio :label="1" style="margin-bottom: 10px;">物品借用</el-radio>
						</el-radio-group>
					</div>
					<div class="u-f-item input-box">
						<div class="input-lebal">
							<span>*</span>
							物品名称
						</div>
						<el-select v-model="property_warehouse_id" placeholder="请选择" style="width: 70%;" filterable>
							<el-option v-for="item in assetList" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</div>
					<div class="u-f-item input-box">
						<div class="input-lebal">
							<span>*</span>
							申请数量
						</div>
						<el-input-number v-model="number" :min="1"></el-input-number>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal" style="margin-top: 10px;">
							<span>*</span>
							物品用途
						</div>
						<el-input v-model="purpose" type="textarea" :rows="3" placeholder="请输入物品用途" style="width: 70%;"></el-input>
					</div>
					<div class="u-f input-box" v-if="assettype == 1">
						<div class="input-lebal" style="margin-top: 10px;">
							<span>*</span>
							预期归还日期
						</div>
						<el-date-picker value-format="yyyy-MM-dd" v-model="plantime" type="date" placeholder="选择日期" style="width: 70%;"></el-date-picker>
					</div>
					<div class="u-f-item input-box">
						<div class="input-lebal">
							<span>*</span>
							审批人
						</div>
						<el-select multiple v-model="audit" placeholder="请选择" style="width: 70%;">
							<el-option v-for="item in peopleList" :key="item.id" :label="item.username" :value="item.id"></el-option>
						</el-select>
					</div>
				</div>
				<span slot="footer" class="dialog-footer u-f-item u-f-jsb">
					<el-button @click="closeActivity" size="small">取 消</el-button>
					<el-button type="primary" size="small" @click="submit4()">确 定</el-button>
				</span>
			</el-dialog>
			<!-- 公文流转 -->
			<el-dialog title="公文流转" :visible.sync="activityVisible5" width="600px" :before-close="handleClose">
				<div class="edit-box">
					<div class="u-f input-box">
						<div class="input-lebal" style="margin-top: 5px;">
							<span>*</span>
							文件上传
						</div>
						<div>
							<el-button size="mini" style="position: relative;">
								<input single ref="filElem4" type="file" class="upload-file" @change="getFile4" />
								点击上传
							</el-button>
							<div class="u-f-item u-f-jsb file_box" v-if="file4.name" style="margin-top: 10px;width: 300px;">
								<div class="u-f-item">
									<i class="iconfont icon-excel" style="color: red;margin-right: 3px;"></i>
									{{ file4.name }}
								</div>
								<i class="el-icon-circle-check" style="color: #67C23A;"></i>
								<i class="el-icon-circle-close" style="color: #67C23A;" @click="delFile4"></i>
							</div>
						</div>
					</div>
					<div class="u-f-item input-box">
						<div class="input-lebal">
							<span>*</span>
							文件名称
						</div>
						<el-input v-model="fileTitle" placeholder="请输入文件名称" style="width: 70%;"></el-input>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal">
							<span>*</span>
							紧急程度
						</div>
						<el-radio-group v-model="level" style="width: 80%" @change="radioChange">
							<el-radio :label="1" style="margin-bottom: 10px;">普通</el-radio>
							<el-radio :label="2" style="margin-bottom: 10px;">紧急</el-radio>
							<el-radio :label="3" style="margin-bottom: 10px;">特急</el-radio>
						</el-radio-group>
					</div>
					<div class="u-f-item input-box">
						<div class="input-lebal">
							<span>*</span>
							来文单位
						</div>
						<el-input v-model="origin_units" placeholder="请输入来文单位" style="width: 70%;"></el-input>
					</div>
					<div class="u-f-item input-box">
						<div class="input-lebal">
							<span>*</span>
							来文日期
						</div>
						<el-date-picker value-format="yyyy-MM-dd" v-model="origin_time" type="date" placeholder="选择日期" style="width: 70%;"></el-date-picker>
					</div>
					<div class="u-f-item input-box">
						<div class="input-lebal">
							<span>*</span>
							文件摘要
						</div>
						<el-input v-model="describe" placeholder="请输入文件摘要" style="width: 70%;"></el-input>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal" style="margin-top: 10px;">办理意见</div>
						<el-input v-model="opinion" type="textarea" :rows="3" placeholder="请输入办理意见" style="width: 70%;"></el-input>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal" style="margin-top: 10px;">
							<span>*</span>
							接收人
						</div>
						<el-select multiple v-model="consume_id" placeholder="请选择" filterable style="width: 70%;">
							<el-option v-for="item in consumeList" :key="item.id" :label="item.username" :value="item.id"></el-option>
						</el-select>
					</div>
				</div>
				<span slot="footer" class="dialog-footer u-f-item u-f-jsb">
					<el-button @click="closeActivity" size="small">取 消</el-button>
					<el-button type="primary" size="small" @click="submit5()">确 定</el-button>
				</span>
			</el-dialog>
			<!-- 调课申请 -->
			<el-dialog title="调课申请" :visible.sync="activityVisible6" width="1000px" :before-close="handleClose">
				<div class="edit-box">
					<div class="u-f-item input-box">
						<div class="input-lebal1">
							<span>*</span>
							调课学周
						</div>
						<el-select v-model="week" placeholder="请选择" style="width: 70%;" @change="weekChanage">
							<el-option v-for="item in weekList" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</div>
					<div class="u-f input-box">
						<!-- <div class="input-lebal1"><span>*</span>我的课表</div> -->
						<div style="width: 80%;padding-left: 40px;" v-if="CourseList.length">
							<div class="u-f-item table-head">
								<span class="class_name u-f-justify">我的课表</span>
								<span class="week_name u-f-justify u-f-column" v-for="(it, ind) in attend_day" :key="ind">
									<div class="font_12">{{ it }}</div>
									<!-- <div class="font_12">({{it.day}})</div> -->
								</span>
							</div>
							<div class="u-f-item table-item" v-for="(item, index) in CourseList" :key="index">
								<span class="time_name u-f-justify u-f-column">
									<div class="font_12">{{ item.node }}</div>
									<div class="font_12">{{ item.start }}-{{ item.end }}</div>
								</span>
								<div class="cell u-f-justify u-f-column" :class="index == nodeIndex && a == attendIndex ? 'active' : ''" v-for="(att, a) in attend_day" :key="a">
									<blockquote style="margin:0" v-for="(str, s) in item.list" :key="s" @click="letin(index, str.id, a)">
										<div class="normal_cell" v-if="str.attend_day == att">
											<p class="cell_subject font_12">{{ str.class_name }}</p>
											<p class="cell_teacher font_12">{{ str.teachername || str.discipline_name }}</p>
										</div>
										<!-- <div class="" v-else></div> -->
									</blockquote>
								</div>
							</div>
						</div>
					</div>
					<div class="u-f input-box" v-if="teacherList.length">
						<div class="input-lebal1">
							<span>*</span>
							被调老师
						</div>
						<!-- <el-select  v-model="teacherid" placeholder="请选择" style="width: 70%;" @change="weekChanage">
							<el-option v-for="item in teacherList" :key="item.teacher_id" :label="item.teacher_name" :value="item.teacher_id"></el-option>
						</el-select> -->
						<div class="teacher-list">
							<div class="teacher-item" @click="teacherTap(index)" :class="teacherIndex == index ? 'active' : ''" v-for="(item, index) in teacherList" :key="index">
								{{ item.teacher_name }}
							</div>
						</div>
					</div>
					<div class="u-f-item input-box">
						<div class="input-lebal1">
							<span>*</span>
							审批人
						</div>
						<el-select multiple v-model="audit" placeholder="请选择" style="width: 70%;">
							<el-option v-for="item in peopleList" :key="item.id" :label="item.username" :value="item.id"></el-option>
						</el-select>
					</div>
					<div class="u-f-item input-box">
						<div class="input-lebal1">
							<span>*</span>
							抄送人
						</div>
						<el-select multiple v-model="ectype" placeholder="请选择" style="width: 70%;">
							<el-option v-for="item in peopleList2" :key="item.id" :label="item.username" :value="item.id"></el-option>
						</el-select>
					</div>
				</div>
				<span slot="footer" class="dialog-footer u-f-item u-f-jsb">
					<el-button @click="closeActivity" size="small">取 消</el-button>
					<el-button type="primary" size="small" @click="submit6()">确 定</el-button>
				</span>
			</el-dialog>
			<!-- 详情 -->
			<el-dialog :title="detailsTitle" :visible.sync="activityVisible7" width="650px" :before-close="handleClose">
				<div class="edit-box" v-if="detailsType == 1">
					<div class="u-f-item input-box">
						<div class="input-lebal">活动标题：</div>
						<div>{{ info.title }}</div>
					</div>
					<div class="u-f-item input-box">
						<div class="input-lebal">开始时间：</div>
						<div>{{ info.start_time }}</div>
					</div>
					<div class="u-f-item input-box">
						<div class="input-lebal">结束时间：</div>
						<div>{{ info.end_time }}</div>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal">活动说明：</div>
						<div>{{ info.explain }}</div>
					</div>
					<div class="u-f-item input-box">
						<div class="input-lebal">申请人：</div>
						<div>{{ info.petitioner_name }}</div>
					</div>
					<div class="u-f-item input-box">
						<div class="input-lebal">审核状态：</div>
						<div>{{ info.status_text }}</div>
					</div>
					<div class="u-f-item input-box" v-if="info.audit_opinions">
						<div class="input-lebal">审核备注：</div>
						<div>{{ info.audit_opinions }}</div>
					</div>
				</div>
				<div class="edit-box" v-if="detailsType == 3"></div>
				<div class="edit-box" v-if="detailsType == 2">
					<div class="u-f-item input-box">
						<div class="input-lebal">申请人：</div>
						<div>{{ info.petitioner_name }}</div>
					</div>
					<div class="u-f-item input-box">
						<div class="input-lebal">请假时长：</div>
						<div>{{ info.day }}天</div>
					</div>
					<div class="u-f-item input-box">
						<div class="input-lebal">开始时间：</div>
						<div>{{ info.start_time_text }}</div>
					</div>
					<div class="u-f-item input-box">
						<div class="input-lebal">结束时间：</div>
						<div>{{ info.end_time_text }}</div>
					</div>
					<div class="u-f-item input-box">
						<div class="input-lebal">请假类型：</div>
						<div>{{ info.type_text }}</div>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal">请假说明：</div>
						<div>{{ info.explain }}</div>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal">审核状态：</div>
						<div>{{ info.status_text }}</div>
					</div>
					<div class="u-f-item input-box" v-if="info.audit_opinions">
						<div class="input-lebal">审核备注：</div>
						<div>{{ info.audit_opinions }}</div>
					</div>
				</div>
				<div class="edit-box" v-if="detailsType == 4"></div>
				<div class="edit-box" v-if="detailsType == 5">
					<div class="u-f input-box">
						<div class="input-lebal">设备类型：</div>
						<div>{{ info.type_text }}</div>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal">设备名称：</div>
						<div>{{ info.name }}</div>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal">所在位置：</div>
						<div>{{ info.school_place_text }}{{ info.school_place_floor_text }}{{ info.school_place_room_text }}</div>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal">详细说明：</div>
						<div>{{ info.explain }}</div>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal">申请人：</div>
						<div>{{ info.petitioner_name }}</div>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal">审核状态：</div>
						<div>{{ info.status_text }}</div>
					</div>
					<div class="u-f-item input-box" v-if="info.audit_opinions">
						<div class="input-lebal">审核备注：</div>
						<div>{{ info.audit_opinions }}</div>
					</div>
				</div>
				<div class="edit-box" v-if="detailsType == 6">
					<div class="u-f input-box">
						<div class="input-lebal">学校计划：</div>
						<div>{{ info.plan }}</div>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal">功能室登记表：</div>
						<div class="u-f-item">
							<i class="iconfont icon-excel" style="color: red;margin-right: 5px;"></i>
							<a target="_blank" :href="'http://view.officeapps.live.com/op/view.aspx?src=http://school.blzzxx.cn' + info.media_img">功能室登记表</a>
						</div>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal">考勤表：</div>
						<div class="u-f-item">
							<i class="iconfont icon-excel" style="color: red;margin-right: 5px;"></i>
							<a target="_blank" :href="'http://view.officeapps.live.com/op/view.aspx?src=http://school.blzzxx.cn' + info.attendance_img">考勤表</a>
						</div>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal">活动记录表：</div>
						<div class="u-f-item">
							<i class="iconfont icon-excel" style="color: red;margin-right: 5px;"></i>
							<a target="_blank" :href="'http://view.officeapps.live.com/op/view.aspx?src=http://school.blzzxx.cn' + info.activity_img">活动记录表</a>
						</div>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal">授课照片：</div>
						<div class="u-f-item">
							<el-image
								fit="cover"
								style="width: 80px; height: 80px"
								:src="'http://school.blzzxx.cn' + info.give_img"
								:preview-src-list="['http://school.blzzxx.cn' + info.give_img]"
							></el-image>
						</div>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal">成功照片：</div>
						<div class="u-f-item">
							<el-image
								fit="cover"
								style="width: 80px; height: 80px"
								:src="'http://school.blzzxx.cn' + info.success_img"
								:preview-src-list="['http://school.blzzxx.cn' + info.success_img]"
							></el-image>
						</div>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal">课堂总结：</div>
						<div>{{ info.summarize }}</div>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal">申请人：</div>
						<div>{{ info.petitioner_name }}</div>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal">审核状态：</div>
						<div>{{ info.status_text }}</div>
					</div>
					<div class="u-f-item input-box" v-if="info.audit_opinions">
						<div class="input-lebal">审核备注：</div>
						<div>{{ info.audit_opinions }}</div>
					</div>
				</div>
				<div class="edit-box" v-if="detailsType == 7">
					<div class="u-f input-box">
						<div class="input-lebal">所在位置：</div>
						<div>{{ info.site }}</div>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal">详细描述：</div>
						<div>{{ info.describe }}</div>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal">现场图片：</div>
						<div class="u-f-item">
							<el-image
								v-if="info.file"
								fit="cover"
								style="width: 80px; height: 80px"
								:src="'http://school.blzzxx.cn' + info.file"
								:preview-src-list="['http://school.blzzxx.cn' + info.file]"
							></el-image>
							<span v-if="!info.file">暂无图片</span>
						</div>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal">申请人：</div>
						<div>{{ info.petitioner_name }}</div>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal">审核状态：</div>
						<div>{{ info.status_text }}</div>
					</div>
					<div class="u-f-item input-box" v-if="info.audit_opinions">
						<div class="input-lebal">审核备注：</div>
						<div>{{ info.audit_opinions }}</div>
					</div>
				</div>
				<div class="edit-box" v-if="detailsType == 8">
					<div class="u-f input-box">
						<div class="input-lebal">物品编号：</div>
						<div>{{ info.sn }}</div>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal">物品名称：</div>
						<div>{{ info.name }}</div>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal">申请数量：</div>
						<div>{{ info.number }}</div>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal">物品用途：</div>
						<div>{{ info.purpose }}</div>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal">申请人：</div>
						<div>{{ info.petitioner_name }}</div>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal">审核状态：</div>
						<div>{{ info.status_text }}</div>
					</div>
					<div class="u-f-item input-box" v-if="info.audit_opinions">
						<div class="input-lebal">审核备注：</div>
						<div>{{ info.audit_opinions }}</div>
					</div>
				</div>
				<div class="edit-box" v-if="detailsType == 9">
					<div class="u-f input-box">
						<div class="input-lebal">物品编号：</div>
						<div>{{ info.sn }}</div>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal">物品名称：</div>
						<div>{{ info.name }}</div>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal">申请数量：</div>
						<div>{{ info.number }}</div>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal">物品用途：</div>
						<div>{{ info.purpose }}</div>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal">预期归还时间：</div>
						<div>{{ info.plantime }}</div>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal">申请人：</div>
						<div>{{ info.petitioner_name }}</div>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal">审核状态：</div>
						<div>{{ info.status_text }}</div>
					</div>
					<div class="u-f-item input-box" v-if="info.audit_opinions">
						<div class="input-lebal">审核备注：</div>
						<div>{{ info.audit_opinions }}</div>
					</div>
				</div>
				<div class="edit-box" v-if="detailsType == 10">
					<div class="u-f-item input-box">
						<div class="input-lebal">学生姓名：</div>
						<div>{{ info.student_realname }}</div>
					</div>
					<div class="u-f-item input-box">
						<div class="input-lebal">年级：</div>
						<div>{{ info.grade_name }}</div>
					</div>
					<div class="u-f-item input-box">
						<div class="input-lebal">班级：</div>
						<div>{{ info.class_name }}</div>
					</div>
					<div class="u-f-item input-box">
						<div class="input-lebal">请假时长：</div>
						<div>{{ info.day }}天</div>
					</div>
					<div class="u-f-item input-box">
						<div class="input-lebal">开始时间：</div>
						<div>{{ info.start_time_text }}</div>
					</div>
					<div class="u-f-item input-box">
						<div class="input-lebal">结束时间：</div>
						<div>{{ info.end_time_text }}</div>
					</div>
					<div class="u-f-item input-box">
						<div class="input-lebal">请假类型：</div>
						<div>{{ info.type_text }}</div>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal">请假说明：</div>
						<div>{{ info.explain }}</div>
					</div>
					<div class="u-f-item input-box">
						<div class="input-lebal">申请人：</div>
						<div>{{ info.petitioner_name }}</div>
					</div>
					<div class="u-f-item input-box">
						<div class="input-lebal">审核状态：</div>
						<div>{{ info.status_text }}</div>
					</div>
					<div class="u-f-item input-box" v-if="info.audit_opinions">
						<div class="input-lebal">审核备注：</div>
						<div>{{ info.audit_opinions }}</div>
					</div>
				</div>
				<div class="edit-box" v-if="detailsType == 11">
					<div class="u-f-item input-box">
						<div class="input-lebal">发起人：</div>
						<div>{{ info.petitioner_name }}</div>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal">文件名称：</div>
						<div class="u-f1">{{ info.title }}</div>
					</div>
					<div class="u-f-item input-box" v-if="info.file">
						<div class="input-lebal">文件大小：</div>
						<div>{{ info.file.originsize }}kb</div>
					</div>
					<div class="u-f-item input-box" v-if="info.file">
						<div class="input-lebal">文件：</div>
						<div v-if="info.file.type=='jpg'||info.file.type=='png'||info.file.type=='jpeg'||info.file.type=='gif'">
							<el-image
								fit="cover"
								style="width: 80px; height: 80px"
								:src="info.file.fullurl"
								:preview-src-list="[info.file.fullurl]"
							></el-image>
						</div>
						<div v-if="info.file.type!='jpg'&&info.file.type!='png'&&info.file.type!='jpeg'&&info.file.type!='gif'">
							<a :href="'https://view.officeapps.live.com/op/view.aspx?src='+info.file.fullurl" target="_blank">{{info.file.originname}}</a>
						</div>
					</div>
					<div class="u-f-item input-box">
						<div class="input-lebal">来文单位：</div>
						<div>{{ info.origin_units }}</div>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal">文件摘要：</div>
						<div class="u-f1">{{ info.describe }}</div>
					</div>
					<div class="u-f input-box">
						<div class="input-lebal">拟办意见：</div>
						<div class="u-f1">{{ info.opinion }}</div>
					</div>
					<div class="u-f-item input-box">
						<div class="input-lebal">来文日期：</div>
						<div>{{ info.origin_time }}</div>
					</div>
					<div class="u-f-item input-box">
						<div class="input-lebal">紧急程度：</div>
						<div v-if="info.level==1">普通</div>
						<div v-if="info.level==2">紧急</div>
						<div v-if="info.level==3">特急</div>
					</div>
				</div>
				<div style="min-height: 200px;padding-left: 60px;margin-top: 40px;">
					<el-steps direction="vertical">
						<el-step title="审核人" v-if="info.audit&&info.audit.length">
							<div slot="description" style="padding-bottom: 10px;">
								<div v-for="(item,index) in info.audit" :key="index" style="margin-top: 10px;">
									<div class="u-f-item u-f-jsb">
										<div>{{item.audit_username}}</div>
										<div>
											<span v-if="item.handle==0">待上级审批</span>
											<span v-if="item.handle==1">待审批</span>
											<span v-if="item.handle==2">已审批</span>
											<span v-if="item.audit_time">{{item.audit_time|getLocalTime}}</span>
										</div>
									</div>
									<div>{{item.audit_opinions}}</div>
								</div>
							</div>
						</el-step>
						<el-step title="抄送人" v-if="info.ectype&&info.ectype.length">
							<div slot="description" style="padding-bottom: 10px;">
								<div v-for="(item,index) in info.ectype" :key="index" style="margin-top: 10px;">
									<div class="u-f-item u-f-jsb">
										<div>{{item.audit_username}}</div>
										<div>
											<span v-if="info.status==2">已抄送</span>
											<span v-if="info.status==1">待审批</span>
											<span v-if="info.status==3">已拒绝</span>
											<span v-if="info.status==4">已撤回</span>
											<span v-if="info.updatetime">{{info.updatetime|getLocalTime}}</span>
										</div>
									</div>
									<div>{{item.audit_opinions}}</div>
								</div>
							</div>
						</el-step>
						<el-step title="承办人" v-if="info.exec&&info.exec.length">
							<div slot="description">
								<div v-for="(item,index) in info.exec" :key="index" style="margin-top: 10px;">
									<div class="u-f-item u-f-jsb">
										<div>{{item.audit_username}}</div>
										<div>
											<span v-if="item.handle==0">待上级审批</span>
											<span v-if="item.handle==1">待审批</span>
											<span v-if="item.handle==2">已审批</span>
											<span v-if="item.audit_time">{{item.audit_time|getLocalTime}}</span>
										</div>
									</div>
									<div>{{item.audit_opinions}}</div>
								</div>
							</div>
						</el-step>
					</el-steps>
				</div>
			</el-dialog>
			<!-- 审核 -->
			<div id="audit">
				<el-dialog title="审核" :visible.sync="activityVisible8" width="500px" :before-close="handleClose">
					<div class="edit-box">
						<div class="u-f input-box">
							<div class="input-lebal">是否通过</div>
							<el-radio-group v-model="audittype" style="width: 80%">
								<el-radio :label="1" style="margin-bottom: 10px;">通过</el-radio>
								<el-radio :label="2" style="margin-bottom: 10px;">不通过</el-radio>
							</el-radio-group>
						</div>
						<div class="u-f input-box">
							<div class="input-lebal">备注</div>
							<el-input v-model="remark" type="textarea" :rows="5" placeholder="请输入备注" style="width: 70%;"></el-input>
						</div>
					</div>
					<span slot="footer" class="dialog-footer u-f-item u-f-jsb">
						<el-button @click="closeActivity" size="small">取 消</el-button>
						<el-button type="primary" size="small" @click="submitaudit()">确 定</el-button>
					</span>
				</el-dialog>
			</div>
		</index>
	</div>
</template>

<script>
import index from '@/components/common/index.vue';
export default {
	components: {
		index
	},
	data() {
		return {
			nums: [],
			selectShow: false,
			selectList: [],
			nodeIndex: -1,
			attendIndex: -1,
			// , { name: '流程报表' }, { name: '流程配置' }
			Meun: [{ name: '流程审批' }],
			MeunIndex: 0,
			meunLeftIndex: 1,
			total: 0,
			// 活动申请
			activityVisible: false,
			title: '',
			start_time: '',
			end_time: '',
			explain: '',
			main_department_id: '',
			ectype_department_id: '',
			audit: [],
			ectype: [],
			sectionList: [],
			peopleList: [],
			peopleList2: [],
			page: 1,
			limit: 10,
			Mylist: [],
			ids: [],
			approverList: [],
			copyToList: [],
			// 请假申请
			activityVisible1: false,
			start_time1: '',
			end_time1: '',
			day: '',
			type: 1,
			explain: '',
			// 安全隐患
			activityVisible2: false,
			site: '',
			describe: '',
			fileList: [],
			file: '',
			//公开课申请
			activityVisible3: false,
			plan: '',
			summarize: '',
			give_img: '', //授课照片
			success_img: '', //成功照片
			media_img: '', //功能室登记扫描件
			attendance_img: '', //考勤表扫描件
			activity_img: '', //活动记录表扫描件
			fileList2: [],
			fileList1: [],
			file3: '',
			file1: '',
			file2: '',
			// 物品领用
			activityVisible4: false,
			assettype: 2,
			number: '',
			property_warehouse_id: '',
			purpose: '',
			plantime: '',
			assetList: [],
			// 公文流转
			activityVisible5: false,
			fileTitle: '',
			level: 1,
			origin_units: '',
			origin_time: '',
			describe: '',
			opinion: '',
			file4: '',
			fileUrl: '',
			consume_id: [],
			consumeList: [],
			// 调课申请
			activityVisible6: false,
			week: '',
			weekList: [],
			CourseList: [],
			attend_day: [],
			value2: '',
			teacherList: [],
			teacherid: '',
			// 筛选
			info: '',
			activityVisible7: false,
			activityVisible8: false,
			audittype: 1,
			auditId: '',
			detailsTitle: '',
			detailsType: '',
			remark: '',
			filters: [
				{ text: '活动审批', value: '活动审批' },
				{ text: '档案审核', value: '档案审核' },
				{ text: '请假调休', value: '请假调休' },
				{ text: '课程调课', value: '课程调课' },
				{ text: '报修通知', value: '报修通知' },
				{ text: '公开课', value: '公开课' },
				{ text: '安全隐患上报', value: '安全隐患上报' },
				{ text: '物品领用', value: '物品领用' },
				{ text: '物品归还', value: '物品归还' },
				{ text: '学生请假', value: '学生请假' }
			],
			teacherIndex: -1,
			cocourse_id: '',
			teacher_list: [],
			typeIndex: 0,
			dataIndex: 0,
			keys:'',
			selectType:''
		};
	},
	filters:{
		getLocalTime(nS) {  
			return new Date(parseInt(nS) * 1000).toLocaleString().replace(/:\d{1,2}$/,' ');  
		}
	},
	mounted() {
		this.getAssetList();
		this.myActivitList();
		this.getweekList();
		this.getteacherList();
	},
	methods: {
		print(e) {
		    let {href}= this.$router.resolve({
				path: "/print",
				query: {
				    id: e.id,
					type:e.table_type
				}
			});
			window.open(href, '_blank');
		},
		selectShowTap(type){
			this.selectType = type;
			this.selectShow = true;
		},
		// 切换分类
		typeTap(index) {
			this.typeIndex = index;
			this.dataIndex = 0;
		},
		dataTap(index) {
			this.dataIndex = index;
		},
		// 教师列表
		getteacherList() {
			this.$api.pepople.teacherList({}).then(res => {
				if (res.data.code == 1) {
					this.teacher_list = res.data.data;
					for (let i in this.teacher_list) {
						for (let j in this.teacher_list[i].data) {
							for (let t in this.teacher_list[i].data[j].teacher) {
								this.nums = this.nums.concat(this.teacher_list[i].data[j].teacher[t].id);
								this.selectList = this.selectList.concat(this.teacher_list[i].data[j].teacher[t]);
							}
						}
					}
					this.nums = this.unique(this.nums);
					this.selectList = this.unique2(this.selectList);
				}
			});
		},
		unique(arr) {
			// 根据唯一标识orderId来对数组进行过滤
			const res = new Map(); //定义常量 res,值为一个Map对象实例 //返回arr数组过滤后的结果，结果为一个数组   过滤条件是，如果res中没有某个键，就设置这个键的值为1
			return arr.filter(arr => !res.has(arr) && res.set(arr, 1));
		},
		unique2(arr) {
			// 根据唯一标识orderId来对数组进行过滤
			const res = new Map(); //定义常量 res,值为一个Map对象实例 //返回arr数组过滤后的结果，结果为一个数组   过滤条件是，如果res中没有某个键，就设置这个键的值为1
			return arr.filter(arr => !res.has(arr.teacher_id) && res.set(arr.teacher_id, 1));
		},
		// 选择老师
		teachTap(item) {
			let arr = [];
			for (let i in this.teacher_list) {
				for (let j in this.teacher_list[i].data) {
					for (let t in this.teacher_list[i].data[j].teacher) {
						if (this.teacher_list[i].data[j].teacher[t].id == item.id && !this.teacher_list[i].data[j].teacher[t].checked) {
							this.teacher_list[i].data[j].teacher[t].checked = true;
						} else if (this.teacher_list[i].data[j].teacher[t].id == item.id && this.teacher_list[i].data[j].teacher[t].checked) {
							this.teacher_list[i].data[j].teacher[t].checked = false;
						}
						if (this.teacher_list[i].data[j].teacher[t].checked) {
							arr.push(this.teacher_list[i].data[j].teacher[t].id);
						}
					}
				}
			}
			if(this.selectType==1){
				this.audit = arr;
				this.audit = this.unique(this.audit);
			}else if(this.selectType==2){
				this.ectype = arr;
				this.ectype = this.unique(this.audit);
			}
			
		},
		removeTag() {
			for (let i in this.teacher_list) {
				for (let j in this.teacher_list[i].data) {
					for (let t in this.teacher_list[i].data[j].teacher) {
						if(this.selectType==1){
							if (this.audit.length) {
								for (let c in this.audit) {
									if (this.teacher_list[i].data[j].teacher[t].id == this.audit[c]) {
										this.teacher_list[i].data[j].teacher[t].checked = true;
									} else {
										this.teacher_list[i].data[j].teacher[t].checked = false;
									}
								}
							} else {
								this.teacher_list[i].data[j].teacher[t].checked = false;
							}
						}else if(this.selectType==2){
							if (this.ectype.length) {
								for (let c in this.ectype) {
									if (this.teacher_list[i].data[j].teacher[t].id == this.ectype[c]) {
										this.teacher_list[i].data[j].teacher[t].checked = true;
									} else {
										this.teacher_list[i].data[j].teacher[t].checked = false;
									}
								}
							} else {
								this.teacher_list[i].data[j].teacher[t].checked = false;
							}
						}
						
					}
				}
			}
		},
		teacherTap(index) {
			this.teacherIndex = index;
			for (let i in this.CourseList[this.nodeIndex].list) {
				if (this.CourseList[this.nodeIndex].list[i].id == this.cocourse_id) {
					this.CourseList[this.nodeIndex].list[i].teachername = this.teacherList[index].teacher_name;
					this.CourseList[this.nodeIndex].list[i].teacher_id = this.teacherList[index].teacher_id;
				}
			}
		},
		letin(index, id, i) {
			this.nodeIndex = index;
			this.attendIndex = i;
			this.cocourse_id = id;
			// this.getTeacherList(id)
		},
		// 获取学周列表
		getweekList() {
			this.$api.setting
				.getweekList({
					semester_id: window.localStorage.getItem('semester_id')
				})
				.then(res => {
					if (res.data.code == 1) {
						let data = res.data.data.list;
						let arr = [];
						for (let i = 0; i < data.length; i++) {
							arr.push({
								name: data[i],
								id: i + 1
							});
						}
						this.weekList = arr;
					}
				});
		},
		getTeacherList(id) {
			this.$api.rule
				.getTeacherList({
					course_config_id: id,
					week: this.week
				})
				.then(res => {
					if (res.data.code == 1) {
						this.teacherList = res.data.data.teacher_list;
						this.teacherIndex = -1;
					}
				});
		},
		// 学生请假审核
		studentAudit() {
			this.$api.rule
				.studentAudit({
					id: this.auditId,
					status: this.audittype,
					audit_opinions: this.remark
				})
				.then(res => {
					if (res.data.code == 1) {
						this.$message.success('审核成功');
						this.getduplicate(3);
						this.activityVisible8 = false;
					} else {
						this.$message.error(res.data.msg);
					}
				});
		},
		// 活动审核
		activitiesAudit() {
			this.$api.rule
				.activitiesAudit({
					id: this.auditId,
					status: this.audittype,
					audit_opinions: this.remark
				})
				.then(res => {
					if (res.data.code == 1) {
						this.$message.success('审核成功');
						this.getduplicate(3);
						this.activityVisible8 = false;
					} else {
						this.$message.error(res.data.msg);
					}
				});
		},
		// 请假审核
		leaveAudit() {
			this.$api.rule
				.leaveAudit({
					id: this.auditId,
					status: this.audittype,
					audit_opinions: this.remark
				})
				.then(res => {
					if (res.data.code == 1) {
						this.$message.success('审核成功');
						this.getduplicate(3);
						this.activityVisible8 = false;
					} else {
						this.$message.error(res.data.msg);
					}
				});
		},
		// 校园报修审核
		repairAudit() {
			this.$api.rule
				.repairAudit({
					id: this.auditId,
					status: this.audittype,
					audit_opinions: this.remark
				})
				.then(res => {
					if (res.data.code == 1) {
						this.$message.success('审核成功');
						this.getduplicate(3);
						this.activityVisible8 = false;
					} else {
						this.$message.error(res.data.msg);
					}
				});
		},
		// 公开课审核
		openClassAudit() {
			this.$api.rule
				.openClassAudit({
					id: this.auditId,
					status: this.audittype,
					audit_opinions: this.remark
				})
				.then(res => {
					if (res.data.code == 1) {
						this.$message.success('审核成功');
						this.getduplicate(3);
						this.activityVisible8 = false;
					} else {
						this.$message.error(res.data.msg);
					}
				});
		},
		// 安全隐患审核
		potentialAudit() {
			this.$api.rule
				.potentialAudit({
					id: this.auditId,
					status: this.audittype,
					audit_opinions: this.remark
				})
				.then(res => {
					if (res.data.code == 1) {
						this.$message.success('审核成功');
						this.getduplicate(3);
						this.activityVisible8 = false;
					} else {
						this.$message.error(res.data.msg);
					}
				});
		},
		// 资产管理审核
		propertyBorrowAudit() {
			this.$api.rule
				.propertyBorrowAudit({
					id: this.auditId,
					status: this.audittype,
					audit_opinions: this.remark
				})
				.then(res => {
					if (res.data.code == 1) {
						this.$message.success('审核成功');
						this.getduplicate(3);
						this.activityVisible8 = false;
					} else {
						this.$message.error(res.data.msg);
					}
				});
		},
		submitaudit() {
			if (this.detailsType == 1) {
				this.activitiesAudit();
			} else if (this.detailsType == 2) {
			} else if (this.detailsType == 3) {
				this.leaveAudit();
			} else if (this.detailsType == 4) {
			} else if (this.detailsType == 5) {
				this.repairAudit();
			} else if (this.detailsType == 6) {
				this.openClassAudit();
			} else if (this.detailsType == 7) {
				this.potentialAudit();
			} else if (this.detailsType == 8) {
				this.propertyBorrowAudit();
			} else if (this.detailsType == 9) {
				this.propertyBorrowAudit();
			} else if (this.detailsType == 10) {
				this.studentAudit();
			}
		},
		// 审核
		openaudit(e) {
			this.audittype = 1;
			this.remark = '';
			this.detailsType = e.table_type;
			this.auditId = e.id;
			this.activityVisible8 = true;
		},
		// 详情
		openDetails(e) {
			this.detailsTitle = e.title;
			this.detailsType = e.table_type;
			if (e.table_type == 1) {
				this.activitDetails(e.id);
			} else if (e.table_type == 2) {
				this.leaveDetails(e.id);
			} else if (e.table_type == 3) {
			} else if (e.table_type == 4) {
			} else if (e.table_type == 5) {
				this.repairDetails(e.id);
			} else if (e.table_type == 6) {
				this.openClassDetails(e.id);
			} else if (e.table_type == 7) {
				this.potentialDetails(e.id);
			} else if (e.table_type == 8) {
				this.propertyBorrowDetails(e.id);
			} else if (e.table_type == 9) {
				this.propertyBorrowDetails(e.id);
			} else if (e.table_type == 10) {
				this.studentDetails(e.id);
			}else if(e.table_type == 11){
				this.getDocument(e.id)
			}
			this.activityVisible7 = true;
		},
		filterHandler(value, row, column) {
			const property = column['property'];
			return row[property] === value;
		},
		radioChange() {
			this.getAssetList();
		},
		weekChanage(e) {
			this.getCourse(e);
		},
		getFile(e) {
			if (this.$refs.filElem.files.length) {
				this.file2 = this.$refs.filElem.files[0];
				let myfile = this.$refs.filElem;
				let files = myfile.files;
				let file = files[0];
				var formData = new FormData();
				formData.append('file', file);
				this.$api.setting.uploadFile(formData).then(res => {
					if (res.data.code == 1) {
						this.media_img = res.data.data.url;
					} else {
						this.$message.error(res.data.msg);
					}
				});
			}
		},
		delFile() {
			this.file2 = '';
			this.media_img = '';
			this.$refs.filElem.value = '';
		},
		getFile1(e) {
			if (this.$refs.filElem1.files.length) {
				this.file1 = this.$refs.filElem1.files[0];
				let myfile = this.$refs.filElem1;
				let files = myfile.files;
				let file = files[0];
				var formData = new FormData();
				formData.append('file', file);
				this.$api.setting.uploadFile(formData).then(res => {
					if (res.data.code == 1) {
						this.attendance_img = res.data.data.url;
					} else {
						this.$message.error(res.data.msg);
					}
				});
			}
		},
		delFile1() {
			this.file1 = '';
			this.attendance_img = '';
			this.$refs.filElem1.value = '';
		},
		getFile2(e) {
			if (this.$refs.filElem2.files.length) {
				this.file2 = this.$refs.filElem2.files[0];
				let myfile = this.$refs.filElem2;
				let files = myfile.files;
				let file = files[0];
				var formData = new FormData();
				formData.append('file', file);
				this.$api.setting.uploadFile(formData).then(res => {
					if (res.data.code == 1) {
						this.activity_img = res.data.data.url;
					} else {
						this.$message.error(res.data.msg);
					}
				});
			}
		},
		delFile2() {
			this.file2 = '';
			this.$refs.filElem2.value = '';
			this.activity_img = '';
		},
		getFile4(e) {
			if (this.$refs.filElem4.files.length) {
				this.file4 = this.$refs.filElem4.files[0];
				let myfile = this.$refs.filElem4;
				let files = myfile.files;
				let file = files[0];
				var formData = new FormData();
				formData.append('file', file);
				this.$api.setting.uploadFile(formData).then(res => {
					if (res.data.code == 1) {
						this.fileUrl = res.data.data;
						this.fileTitle = res.data.data.originname;
					} else {
						this.$message.error(res.data.msg);
					}
				});
			}
		},
		delFile4() {
			this.file4 = '';
			this.$refs.filElem4.value = '';
			this.fileUrl = '';
		},
		handlePreview(e) {
			this.file = e.data.url;
		},
		handleRemove(e) {
			this.file = '';
		},
		handlePreview1(e) {
			this.give_img = e.data.url;
		},
		handleRemove1(e) {
			this.give_img = '';
		},
		handlePreview2(e) {
			this.success_img = e.data.url;
		},
		handleRemove2(e) {
			this.success_img = '';
		},
		// 关闭弹窗
		closeActivity() {
			this.reset();
			this.activityVisible = false;
			this.activityVisible1 = false;
			this.activityVisible2 = false;
			this.activityVisible3 = false;
			this.activityVisible4 = false;
			this.activityVisible5 = false;
			this.activityVisible6 = false;
			this.activityVisible8 = false;
		},
		handleClose(done) {
			this.reset();
			done();
		},
		handleClose2(done) {
			done();
		},
		// 分页
		handleSizeChange(val) {
			console.log(`每页 ${val} 条`);
		},
		handleCurrentChange(val) {
			this.page = val;
			if (this.meunLeftIndex == 1) {
				this.myActivitList();
			} else if (this.meunLeftIndex == 2) {
				this.getduplicate(1);
			} else if (this.meunLeftIndex == 3) {
				this.getduplicate(3);
			} else if (this.meunLeftIndex == 4) {
				this.getduplicate(4);
			}
		},
		// 选中
		handleSelectionChange(val) {
			let arr = [];
			for (let i in val) {
				arr.push(val[i].id);
			}
			this.ids = arr;
			console.log(this.ids);
		},
		// 数据重置
		reset() {
			this.title = '';
			this.start_time = '';
			this.end_time = '';
			this.explain = '';
			this.main_department_id = '';
			this.ectype_department_id = '';
			this.audit = [];
			this.ectype = [];
			this.start_time1 = '';
			this.end_time1 = '';
			this.day = '';
			this.type = 1;
			this.explain = '';
			this.site = '';
			this.describe = '';
			this.file = '';
			this.fileList = [];
			this.plan = '';
			this.give_img = '';
			this.success_img = '';
			this.media_img = '';
			this.attendance_img = '';
			this.activity_img = '';
			this.summarize = '';
			this.fileList1 = [];
			this.fileList2 = [];
			this.file1 = '';
			this.file2 = '';
			this.file3 = '';
			if (this.activityVisible3) {
				this.$refs.filElem1.value = '';
				this.$refs.filElem2.value = '';
				this.$refs.filElem.value = '';
			}
			this.assettype = 2;
			this.number = '';
			this.property_warehouse_id = '';
			this.purpose = '';
			this.plantime = '';
			this.fileTitle = '';
			this.file4 = '';
			this.fileUrl = '';
			this.level = '';
			this.consume_id = [];
			this.origin_units = '';
			this.origin_time = '';
			this.describe = '';
			this.opinion = '';
			if (this.activityVisible5) {
				this.$refs.filElem4.value = '';
			}
		},
		
		twacherTap(index) {
			this.MeunIndex = index;
		},
		meunLeftTap(index) {
			this.meunLeftIndex = index;
			this.page = 1;
			if (index == 1) {
				this.myActivitList();
			} else if (index == 2) {
				this.getduplicate(1);
			} else if (index == 3) {
				this.getduplicate(3);
			} else if (index == 4) {
				this.getduplicate(4);
			}
		},
		mainChanage(e) {
			this.userList(e);
		},
		ectypeChanage(e) {
			this.userList2(e);
		},
		// 获取资产列表
		getAssetList() {
			let data = {
				mold: this.assettype
			};
			if (this.sid) {
				data.category_ids = this.sid;
			}
			this.$api.asset
				.getAssetList({
					page: 1,
					limit: 999,
					filter: JSON.stringify(data)
				})
				.then(res => {
					if (res.data.code == 1) {
						this.assetList = res.data.data.rows;
					}
				});
		},
		// 活动申请
		submit() {
			let data = {
				// school_campus_id:this.condition,
				year_id: this.year,
				semester_id: this.semester,
				title: this.title,
				start_time: this.start_time,
				end_time: this.end_time,
				explain: this.explain,
				main_department_id: this.main_department_id,
				ectype_department_id: this.ectype_department_id,
				audit: this.audit,
				ectype: this.ectype
			};
			this.$api.rule.addActivit(data).then(res => {
				if (res.data.code == 1) {
					this.$message.success('提交成功');
					this.myActivitList();
					this.closeActivity();
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		// 请假申请
		// 请假申请
		submit1() {
			let data = {
				start_time: this.start_time1,
				end_time: this.end_time1,
				explain: this.explain,
				main_department_id: this.main_department_id,
				ectype_department_id: this.ectype_department_id,
				audit: this.audit,
				ectype: this.ectype,
				day: this.day,
				type: this.type
			};
			this.$api.rule.addLeave(data).then(res => {
				if (res.data.code == 1) {
					this.$message.success('提交成功');
					this.myActivitList();
					this.closeActivity();
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		// 安全隐患申报
		submit2() {
			let data = {
				site: this.site,
				describe: this.describe,
				file: this.file,
				main_department_id: this.main_department_id,
				ectype_department_id: this.ectype_department_id,
				audit: this.audit,
				ectype: this.ectype
			};
			this.$api.rule.addPotential(data).then(res => {
				if (res.data.code == 1) {
					this.$message.success('提交成功');
					this.myActivitList();
					this.closeActivity();
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		// 添加公开课
		submit3() {
			let data = {
				plan: this.plan,
				give_img: this.give_img,
				success_img: this.success_img,
				media_img: this.media_img,
				attendance_img: this.attendance_img,
				activity_img: this.activity_img,
				summarize: this.summarize,
				main_department_id: this.main_department_id,
				audit: this.audit,
				ectype_department_id: this.ectype_department_id,
				ectype: this.ectype
			};
			this.$api.rule.addOpenClass(data).then(res => {
				if (res.data.code == 1) {
					this.$message.success('添加成功');
					this.myActivitList();
					this.closeActivity();
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		// 物品领用
		submit4() {
			let data = {
				property_warehouse_id: this.property_warehouse_id,
				number: this.number,
				purpose: this.purpose,
				main_department_id: this.main_department_id,
				audit: this.audit
			};
			if (this.assettype == 1) {
				if ((this.plantime = '' || !this.plantime)) {
					return this.$message.error('请选择预期归还日期');
				}
				data.plantime = this.plantime;
			}
			this.$api.asset.receive(data).then(res => {
				if (res.data.code == 1) {
					this.$message.success('提交成功');
					this.myActivitList();
					this.closeActivity();
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		// 公文流转
		submit5() {
			let data = {
				title: this.fileTitle,
				file: this.fileUrl,
				level: this.level,
				consume_id: this.consume_id.toString(),
				origin_units: this.origin_units,
				origin_time: this.origin_time,
				describe: this.describe,
				opinion: this.opinion
			};
			this.$api.file.addDocument(data).then(res => {
				if (res.data.code == 1) {
					this.$message.success('添加成功');
					this.myActivitList();
					this.closeActivity();
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		// 获取我的请列表
		myActivitList() {
			let data = {
				page: this.page,
				limit: this.limit
			};
			this.$api.rule.getMyFlow(data).then(res => {
				if (res.data.code == 1) {
					let data = res.data.data.rows;
					for (let i in data) {
						data[i].createtime = this.$common.timeToDate(data[i].createtime);
					}
					this.Mylist = data;
					this.total = res.data.data.total;
				}
			});
		},
		// 删除活动申请
		delActivit() {
			let _this = this;
			if (this.ids.length) {
				this.$confirm('确定要删除？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消'
				}).then(() => {
					this.$api.rule
						.delActivit({
							id: this.ids
						})
						.then(res => {
							if (res.data.code == 1) {
								_this.$message.success('删除成功');
								_this.myActivitList();
							} else {
								_this.$message.error(res.data.msg);
							}
						});
				});
			} else {
				this.$message.error('请选择要删除的数据');
			}
		},
		getduplicate(type) {
			let data = {
				page: this.page, // 	1 	string 	是 	分页
				limit: this.limit,
				type: type
			};
			this.$api.rule.getduplicate(data).then(res => {
				if (res.data.code == 1) {
					let data = res.data.data.rows;
					for (let i in data) {
						data[i].createtime = this.$common.timeToDate(data[i].createtime);
					}
					this.total = res.data.data.total;
					this.copyToList = data;
				}
			});
		},
		// 获取可调课信息列表
		getCourse(e) {
			this.$api.rule
				.getCourse({
					week: e
				})
				.then(res => {
					if (res.data.code == 1) {
						this.CourseList = res.data.data.data;
						this.attend_day = res.data.data.attend_day;
					} else {
						this.$message.error(res.data.msg);
					}
				});
		},
		// 学生请假详情
		studentDetails(id) {
			this.$api.rule.studentDetails({ id: id }).then(res => {
				if (res.data.code == 1) {
					this.info = res.data.data;
				}
			});
		},
		// 活动详情
		activitDetails(id) {
			this.$api.rule.activitDetails({ id: id }).then(res => {
				if (res.data.code == 1) {
					this.info = res.data.data;
				}
			});
		},
		// 请假详情
		leaveDetails(id) {
			this.$api.rule.leaveDetails({ id: id }).then(res => {
				if (res.data.code == 1) {
					this.info = res.data.data;
				}
			});
		},
		// 校园报修repairDetails
		repairDetails(id) {
			this.$api.rule.repairDetails({ id: id }).then(res => {
				if (res.data.code == 1) {
					this.info = res.data.data;
				}
			});
		},
		// 公开课open_class
		openClassDetails(id) {
			this.$api.rule.openClassDetails({ id: id }).then(res => {
				if (res.data.code == 1) {
					this.info = res.data.data;
				}
			});
		},
		// 安全隐患
		potentialDetails(id) {
			this.$api.rule.potentialDetails({ id: id }).then(res => {
				if (res.data.code == 1) {
					this.info = res.data.data;
				}
			});
		},
		// 资产管理
		propertyBorrowDetails(id) {
			this.$api.rule.propertyBorrowDetails({ id: id }).then(res => {
				if (res.data.code == 1) {
					this.info = res.data.data;
				}
			});
		},
		// 公文流转详情
		getDocument(id){
			this.$api.rule.getDocument({ id: id }).then(res => {
				if (res.data.code == 1) {
					this.info = res.data.data;
				}
			});
		}
	}
};
</script>

<style lang="scss">
.el_option {
	display: none !important;
}
#liucheng {
	.head {
		background-color: #ffffff;
		padding: 10px 30px;
		margin-top: 15px;
		.span {
			margin-right: 10px;
			background-color: #f9f9f9;
			color: #8d9da6;
			padding: 3px 10px;
		}
	}
	.nav-tab-bar-box {
		background-color: #ffffff;
		padding: 0.52vw;
		margin-top: 1.04vw;
		.nav-tab-bar {
			.nav-tab-item {
				color: #6e7a87;
				padding: 0 0.78125vw;
				border-right: 1px solid #f3f3f3;
				cursor: pointer;
				-webkit-touch-callout: none;
				-webkit-user-select: none;
				-khtml-user-select: none;
				-moz-user-select: none;
				-ms-user-select: none;
				user-select: none;
			}
			&div:last-child {
				border-right: none;
			}
			.active {
				font-size: 0.833vw;
				color: #63acff;
				position: relative;
				font-weight: bold;
			}
			.active::after {
				position: absolute;
				content: '';
				height: 2px;
				left: 0.78125vw;
				right: 0.78125vw;
				background-color: #63acff;
				bottom: -0.53125vw;
			}
		}
	}
	.content {
		background-color: #ffffff;
		height: 79vh;
		margin-top: 20px;
		.content-left {
			width: 20%;
			border-right: 1px dashed #eeeeee;
			height: 72vh;
			padding: 30px 20px 30px 30px;
			.meun-item {
				cursor: pointer;
				padding: 10px 20px;
				color: #96a2aa;
				.iconfont {
					margin-right: 10px;
				}
			}
			.meun-active {
				background-color: #ddeeff;
				color: #3f9ffe;
			}
		}
		.content-right {
			width: 80%;
			height: 68vh;
			padding: 15px 20px;
			.title {
				padding: 0 0 15px 0;
				.btn {
					background-color: #f5f5f5;
					padding: 5px;
				}
				.btn:hover {
					color: #4998ff;
					background: #e4f1ff;
					cursor: pointer;
				}
			}
			.el-col {
				margin-bottom: 20px;
			}
			.content-item {
				border: 2px solid #f2f3f4;
				.box1 {
					padding: 35px 20px;
					i {
						color: #1890ff;
						margin-right: 5px;
						font-size: 20px;
					}
					span {
						font-weight: bold;
					}
				}
				.btn {
					background-color: #fafafa;
					padding: 10px 0;
					color: #b5bdc2;
					cursor: pointer;
				}
			}
		}
	}

	.el-table th > .cell,
	.el-table .cell {
		overflow: hidden; /*超出部分隐藏*/
		white-space: nowrap; /*不换行*/
		text-overflow: ellipsis; /*超出部分文字以...显示*/
	}
	.el-table thead {
		background: #fafafa !important;
	}
	.el-table th {
		padding: 15px 5px !important;
		background: #fafafa !important;
	}
	.el-table::before {
		left: 0;
		bottom: 0;
		width: 100%;
		height: 0;
	}

	.el-dialog__header {
		border-bottom: 1px solid #eeeeee;
		padding: 10px 20px;
		.el-dialog__title {
			font-size: 16px;
		}
	}
	.el-dialog__body {
		padding: 0 20px 35px 20px;
		height: 600px;
		overflow-y: auto;
		.edit-box {
			.input-box {
				margin-top: 35px;
				padding-left: 15px;
				.input-lebal {
					width: 20%;
					text-align: right;
					color: #aeb5b8;
					margin-right: 10px;
					span {
						color: #ff7a65;
						margin-right: 3px;
					}
				}
				.input-lebal1 {
					width: 5vw;
					text-align: right;
					color: #aeb5b8;
					margin-right: 10px;
					span {
						color: #ff7a65;
						margin-right: 3px;
					}
				}
				.el-icon-remove-outline {
					font-size: 1.5625vw;
					color: #d7d9db;
					margin-left: 10px;
				}
				.upload-file {
					position: absolute;
					left: 0;
					right: 0;
					top: 0;
					bottom: 0;
					opacity: 0;
					cursor: pointer;
				}
				.file_box {
					padding: 5px;
					.el-icon-circle-check {
						display: block;
					}
					.el-icon-circle-close {
						display: none;
					}
				}
				.file_box:hover {
					color: #007aff;
					background-color: #f6f8fb;
					.el-icon-circle-check {
						display: none;
					}
					.el-icon-circle-close {
						display: block;
					}
				}
				.el-upload__tip {
					color: #ccc;
				}

				.table-head {
					height: 50px;
					min-height: 21.33333333px;
					background-color: #f6f8fb;
					border-bottom: 1px solid #f0f2f5;
					.class_name {
						font-weight: 700;
						height: 100%;
						border-right: 1px solid #f0f2f5;
						width: 4.85416667vw;
						min-width: 39.46666667px;
						color: #68b0fd;
						font-size: 0.729vw;
					}
					.week_name {
						height: 100%;
						border-right: 1px solid #f0f2f5;
						flex: 1;
						min-width: 64px;
						border-right: 1px solid #f0f2f5;
						color: #8b8b8d;
						font-size: 0.7291666666666666vw;
					}
				}
				.table-item {
					height: 50px;
					min-height: 26.66666667px;
					border-bottom: 1px solid #f0f2f5;
					.time_name {
						height: 100%;
						background-color: #f6f8fb;
						width: 4.85416667vw;
						min-width: 39.46666667px;
						border-right: 1px solid #f0f2f5;
						color: #8b8b8d;
						font-size: 0.7291666666666666vw;
					}
					.cell {
						position: relative;
						overflow-x: hidden;
						height: 100%;
						border-right: 1px solid #f0f2f5;
						width: 6.25vw;
						flex: 1;
						min-width: 64px;
						cursor: pointer;
						display: -webkit-box;
						display: -ms-flexbox;
						display: flex;
						-webkit-box-pack: center;
						-ms-flex-pack: center;
						justify-content: center;
						-webkit-box-align: center;
						-ms-flex-align: center;
						align-items: center;
						-webkit-box-orient: vertical;
						-webkit-box-direction: normal;
						-ms-flex-direction: column;
						flex-direction: column;
						transition: all 0.2s ease 0s;
						-moz-transition: all 0.2s ease 0s;
						-webkit-transition: all 0.2s ease 0s;
						-o-transition: all 0.2s ease 0s;
						-ms-transition: all 0.2s ease 0s;
						p {
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
							width: 4.94791667vw;
							min-width: 50.66666667px;
							margin: 0;
							padding: 0;
							border: 0;
							text-align: center;
							// font-size: 0.7291666666666666vw;
						}
						.cell_subject {
							color: #6f6f6f;
							margin-bottom: 0.26041667vw;
						}
						.cell_teacher {
							color: #a9b8c0;
						}
					}
					.active {
						background-color: #1890ff;
						.cell_teacher {
							color: #ffffff;
						}
						.cell_subject {
							color: #ffffff;
						}
					}
				}
				.teacher-list {
					display: flex;
					flex-wrap: wrap;
					width: 72%;
					.teacher-item {
						width: 100px;
						height: 30px;
						line-height: 30px;
						border-radius: 5px;
						text-align: center;
						margin-right: 10px;
						background-color: #eeeeee;
						margin-bottom: 10px;
						cursor: pointer;
					}
					.active {
						background-color: #007aff;
						color: #ffffff;
					}
				}
			}
			.avatar-uploader .el-upload {
				border: 1px dashed #d9d9d9;
				border-radius: 6px;
				cursor: pointer;
				position: relative;
				overflow: hidden;
			}
			.avatar-uploader .el-upload:hover {
				border-color: #409eff;
			}
			.avatar-uploader-icon {
				font-size: 28px;
				color: #8c939d;
				width: 90px;
				height: 90px;
				line-height: 90px;
				text-align: center;
			}
			.avatar {
				width: 90px;
				height: 90px;
				display: block;
			}
		}
	}
	.el-dialog__footer {
		padding: 15px 20px 15px;
		box-shadow: 0px -5px 10px -5px #eeeeee;
	}
	#audit {
		.el-dialog__body {
			padding: 0 20px 35px 20px;
			height: 300px;
		}
	}
}
.selectShow {
	.el-dialog__header {
		border-bottom: 1px solid #eeeeee;
		padding: 10px 20px;
		.el-dialog__title {
			font-size: 16px;
		}
	}
	.el-dialog__body {
		padding: 0;
		.user-list-box {
			.user-list-head {
				padding: 10px 20px;
				border-bottom: 1px solid #eeeeee;
				.user-type-list {
					.user-type-item {
						color: #8d9da6;
						cursor: pointer;
					}
					.active {
						color: #007aff;
						position: relative;
					}
					.active::after {
						position: absolute;
						width: 25px;
						height: 2px;
						background-color: #007aff;
						content: '';
						bottom: -5px;
						left: 0;
					}
					span {
						color: #cccccc;
						margin: 0 8px;
					}
				}
			}
			.user-list-content {
				height: 40vh;
				.left {
					height: 98%;
					overflow-y: auto;
					border-right: 1px solid #eeeeee;
					padding-top: 5px;
					.left-item {
						padding: 0 20px;
						height: 40px;
						line-height: 40px;
						color: #a4a4a4;
						cursor: pointer;
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
					}
					.active {
						background-color: #e4f1ff;
						color: #2d8cf0;
						position: relative;
					}
					.active:after {
						position: absolute;
						top: 0;
						bottom: 0;
						right: 0;
						width: 2px;
						content: '';
						background-color: #2d8cf0;
					}
				}
				.right {
					height: 37vh;
					padding: 10px 25px;
					overflow-y: auto;
					.list {
						display: flex;
						flex-wrap: wrap;
						.item {
							cursor: pointer;
							padding: 5px 15px;
							border-radius: 3px;
							background-color: #f3f3f3;
							margin-right: 10px;
							margin-bottom: 10px;
						}
						.active {
							background-color: #e4f1ff;
							color: #2d8cf0;
						}
					}
				}
			}
		}
	}
	.dialog-title {
		padding: 10px 0 5px 0;
	}
	.el-dialog__footer {
		padding: 15px 20px 15px;
		box-shadow: 0px -5px 10px -5px #eeeeee;
	}
}
.el-step__description{
	padding-right: 0!important;
}
</style>
